import { render, staticRenderFns } from "./BlogManagePage.vue?vue&type=template&id=4d0713bd&scoped=true&"
import script from "./BlogManagePage.vue?vue&type=script&lang=js&"
export * from "./BlogManagePage.vue?vue&type=script&lang=js&"
import style0 from "./BlogManagePage.vue?vue&type=style&index=0&id=4d0713bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0713bd",
  null
  
)

export default component.exports